<!--
layout布局  :https://2x.antdv.com/components/layout-cn#components-layout-demo-responsive
vue过度动画 :https://next.router.vuejs.org/zh/guide/advanced/transitions.html
-->
<template>
  <a-layout class="layout">
    <!-- 侧边栏 -->
    <a-layout-sider
      width="160"
      collapsedWidth="64"
      :collapsed="!isOpen"
      theme="light"
      class="layout-sider"
    >
      <the-nav />
    </a-layout-sider>
    <!-- 中间主体函数 -->
    <a-layout class="layout-main">
      <!-- 主体头部 -->
      <a-layout-header class="content-header">
        <the-header></the-header>
      </a-layout-header>
      <!-- 中间展示部分 -->
      <a-layout-content>
        <div class="content-view clearfix" ref="contentRef">
          <router-view v-slot="{ Component }">
            <transition name="fade">
              <keep-alive :include="includeRoutes">
                <component :is="Component" />
              </keep-alive>
            </transition>
          </router-view>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { useStore } from 'vuex'
import {
  computed,
  defineAsyncComponent,
  defineComponent,
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick
} from 'vue'
import TheNav from './components/TheNav/index.vue'
import ResizeHandler from './mixin/ResizeHandler'
import { useRouter } from 'vue-router'
import { useWatermark } from '@/utils/watermark'

export default defineComponent({
  mixins: [ResizeHandler],
  components: {
    TheNav,
    TheHeader: defineAsyncComponent(() => import('./components/TheHeader/index.vue'))
  },
  setup() {
    const { setWatermark, clear, updateWatermark } = useWatermark()
    const store = useStore()
    const contentRef = ref(null)
    const isOpen = computed(() => store.state.app.sidebarStatus)
    const userInfo = computed(() => store.getters.userInfo)
    /**
     * keep-alive 中需要存的路由
     */
    const { options } = useRouter()
    const router = useRouter()
    const { routes } = options
    const _routes = computed(() => {
      let [_routes] = routes.filter(r => !r.hidden)
      _routes = _routes.children
      return _routes
    })
    const includeRoutes = ref('')
    includeRoutes.value = _routes.value.map(r => r.name)
    includeRoutes.value = includeRoutes.value.join()
    watch(
      () => router.currentRoute.value,
      val => {
        const { path } = val
        const arr = ['/helper', '/doctor', '/patient'] // 需要加水印的路由
        nextTick(() => {
          if (arr.includes(path)) {
            const { erpId, realName } = userInfo.value
            const str = realName + ' ' + erpId
            const { clientHeight: height, clientWidth: width } = contentRef.value
            updateWatermark({ str, width, height })
          } else {
            updateWatermark({ bg: true })
          }
        })
      },
      {
        immediate: true
      }
    )
    onMounted(() => {
      const { erpId, realName } = userInfo.value
      contentRef?.value && setWatermark(realName + ' ' + erpId, contentRef)
    })
    onBeforeUnmount(() => {
      clear()
    })
    return { isOpen, includeRoutes, contentRef }
  }
})
</script>
<style lang="scss" scoped>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
// https://cn.vuejs.org/v2/guide/transitions.html/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.fade-enter-active {
  transition: 0.5s;
}
.fade-leave-active {
  transition: 0.5s;
}
/* .slide-fade-leave-active for below version 2.1.8 */
.fade-enter,
.fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.layout {
  &-main {
    .content-header {
      background: #fff;
      padding: 0;
      height: 48px;
      line-height: 48px;
    }
    .content-view {
      margin-left: 2px;
      height: calc(100vh - 48px);
      position: relative;
      overflow: hidden;
    }
    .clearfix::after {
      content: '';
      display: block;
      clear: both;
    }
  }
}
</style>
